import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontSize: '1rem',
    width: '14rem',
    minWidth: '14rem',
    height: '18.5rem',
    borderRadius: 'var(--border-radius-md)',
    border: 'var(--border-neutral-normal)',
    boxSizing: 'border-box',
    cursor: 'pointer',
    transition: 'border-color .25s ease-in-out, background-color .25s ease-in-out',
    '&:hover': {
      borderColor: 'var(--border-color-neutral-emphasis)',
      cursor: 'pointer',
      boxShadow: '0px 4px 24px 0px rgba(15, 17, 49, 0.12)'
    }
  }
}))

const CardItem = ({ children }) => {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      {children}
    </div>
  )
}

CardItem.propTypes = {
  children: PropTypes.node
}

export default CardItem
